import { Component, Input, OnInit } from '@angular/core';
import { CoreSeoPages } from '@app/store/enums/core-seo-pages';
import { FAQCategories, FAQInterface, FaqsService } from '../../services/faqs.service';
import { SeoService } from '../../services/seo.service';

@Component({
    selector: 'app-core-faqs-landing-page',
    templateUrl: './core-faqs-landing-page.component.html',
    styleUrls: ['./core-faqs-landing-page.component.scss']
})
export class CoreFaqsLandingPageComponent implements OnInit {

    faqs: FAQInterface[] = []
    @Input() category = FAQCategories.GENERAL

    categories_obj = {
        GENERAL: FAQCategories.GENERAL
    }

    constructor(
        private seo: SeoService,
        private faqService: FaqsService
    ) {
    }

    ngOnInit(): void {
        this.faqs = this.faqService.getFAQs().filter(faq => faq.categories.includes(this.category))
        if (this.category === FAQCategories.GENERAL) this.seo.generateMetaTags(CoreSeoPages.FAQS)
    }

}
